import { render, staticRenderFns } from "./StageTask.vue?vue&type=template&id=68606fbd&"
import script from "./StageTask.vue?vue&type=script&lang=js&"
export * from "./StageTask.vue?vue&type=script&lang=js&"
import style0 from "./StageTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68606fbd')) {
      api.createRecord('68606fbd', component.options)
    } else {
      api.reload('68606fbd', component.options)
    }
    module.hot.accept("./StageTask.vue?vue&type=template&id=68606fbd&", function () {
      api.rerender('68606fbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/GuideChildren/KpidataChildren/StageTask.vue"
export default component.exports